var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('v-snackbar',{attrs:{"bottom":"","right":"","value":_vm.updateExists,"color":"primary"}},[_vm._v(" Nueva versión del sistema disponible "),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.refreshApp}},[_vm._v(" Actualizar ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }